"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pagination.navigation': 'Onboarding Navigation',
    'onboarding.pagination.step.1': 'Step 1',
    'onboarding.pagination.step': 'Step',
};
